import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card p-6 sm:p-8 mb-4"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title-main" }, "สรุปการสั่งซื้อ", -1)
const _hoisted_5 = { class: "flex flex-col space-y-2 px-2 py-4" }
const _hoisted_6 = { class: "flex flex-row text-base" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "ราคา", -1)
const _hoisted_8 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-row text-base"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "ส่วนลด", -1)
const _hoisted_11 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-row text-base"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "ค่าขนส่ง", -1)
const _hoisted_14 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_15 = {
  key: 2,
  class: "flex flex-row text-base"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "ยอดรวมก่อนภาษี", -1)
const _hoisted_17 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_18 = {
  key: 3,
  class: "flex flex-row text-base"
}
const _hoisted_19 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_20 = {
  key: 4,
  class: "flex flex-row text-base"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "ยอดรวมทั้งสิ้น", -1)
const _hoisted_22 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_23 = { class: "flex flex-col space-y-2 px-2 py-4" }
const _hoisted_24 = { class: "flex flex-row items-center mb-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-base" }, "ราคารวม:", -1)
const _hoisted_26 = {
  class: "flex text-xl flex-auto justify-end",
  style: {"color":"#31bfc7"}
}
const _hoisted_27 = { class: "flex flex-col space-y-2 px-2 py-4" }
const _hoisted_28 = { class: "flex flex-row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, "ราคาสินค้ารวม", -1)
const _hoisted_30 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_31 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", null, "ส่วนลด", -1)
const _hoisted_33 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_34 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "ค่าขนส่ง", -1)
const _hoisted_36 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_37 = {
  key: 2,
  class: "flex flex-row"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, "ยอดรวมก่อนภาษี", -1)
const _hoisted_39 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_40 = {
  key: 3,
  class: "flex flex-row"
}
const _hoisted_41 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("hr", { class: "h-0.5" }, null, -1)
const _hoisted_43 = {
  key: 4,
  class: "flex flex-row"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, "ยอดรวมทั้งสิ้น", -1)
const _hoisted_45 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_46 = {
  key: 5,
  class: "flex flex-row"
}
const _hoisted_47 = { class: "flex flex-auto justify-end text-gray-400" }
const _hoisted_48 = { class: "flex flex-col space-y-2 px-2 py-4" }
const _hoisted_49 = { class: "flex flex-row items-center mb-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, "ยอดที่ต้องชำระ", -1)
const _hoisted_51 = {
  class: "flex text-xl flex-auto justify-end",
  style: {"color":"#31bfc7"}
}
const _hoisted_52 = {
  key: 0,
  class: "flex flex-col space-y-2 px-2 py-4"
}
const _hoisted_53 = { class: "hidden bottom-0 left-0 w-full z-20 p-3 xl:p-0 bg-white xl:bg-unset xl:block flex flex-row" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = {
  key: 0,
  class: "flex flex-col space-y-2 px-2 py-4"
}
const _hoisted_56 = { class: "fixed bottom-0 left-0 w-full p-3 bg-white z-20 xl:relative flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_paymentConfirmDialog = _resolveComponent("paymentConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "bullet_main",
              src: require('@/assets/icon_bullet/summarize.svg'),
              alt: ""
            }, null, 8, _hoisted_3),
            _hoisted_4
          ]),
          (_ctx.$route.params.type === 'salepage')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.subtotalAmount) || 0) + " บาท ", 1)
                  ]),
                  (_ctx.data.accountingData.discount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.discount) || 0) + " บาท ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.data.hasNoShipment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.data.accountingData.shippingCost == null
              ? "รอเลือกการขนส่ง"
              : _ctx.data.accountingData.shippingCost == 0
                ? "ฟรีค่าจัดส่ง"
                : _ctx.func_service.currency(_ctx.data.accountingData.shippingCost)) + " " + _toDisplayString(_ctx.data.accountingData.shippingCost == null
              ? ""
              : _ctx.data.accountingData.shippingCost == 0
                ? ""
                : "บาท"), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.data.accountingData.isVatInc && _ctx.data.accountingData.vatPercentage !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.netAmount)) + " บาท ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.data.accountingData.isVatInc && _ctx.data.accountingData.vatPercentage !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("p", null, "ภาษีมูลค่าเพิ่ม (" + _toDisplayString(_ctx.data.accountingData.vatPercentage) + "%)", 1),
                        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.vat)) + " บาท ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.data.accountingData.isVatInc && _ctx.data.accountingData.vatPercentage !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.grandTotalAmount)) + " บาท ", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.grandTotalAmount) || 0) + " บาท ", 1)
                  ])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.subtotalAmount)) + " บาท ", 1)
                  ]),
                  (_ctx.data.accountingData.discount > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.discount)) + " บาท ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.data.hasNoShipment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.data.accountingData.shippingCost == null
              ? "รอเลือกการขนส่ง"
              : _ctx.data.accountingData.shippingCost == 0
                ? "ฟรีค่าจัดส่ง"
                : _ctx.func_service.currency(_ctx.data.accountingData.shippingCost)) + " " + _toDisplayString(_ctx.data.accountingData.shippingCost == null
              ? ""
              : _ctx.data.accountingData.shippingCost == 0
                ? ""
                : "บาท"), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.data.accountingData.isVatInc && _ctx.data.accountingData.vat !== 0 ||
              _ctx.data.accountingData.taxWithheldPercent !== 0 && _ctx.data.accountingData.vat !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.netAmount)) + " บาท ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.data.accountingData.isVatInc && _ctx.data.accountingData.vat !== 0 ||
          _ctx.data.accountingData.taxWithheldPercent !== 0 && _ctx.data.accountingData.vat !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("p", null, "ภาษีมูลค่าเพิ่ม (" + _toDisplayString(_ctx.data.accountingData.vatPercentage) + "%)", 1),
                        _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.vat)) + " บาท ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_42,
                  (!_ctx.data.accountingData.isVatInc && _ctx.data.accountingData.vat !== 0 ||
          _ctx.data.accountingData.taxWithheldPercent !== 0 && _ctx.data.accountingData.vat !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.grandTotalAmount)) + " บาท ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.accountingData.taxWithheldPercent !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("p", null, " อัตราหัก ณ ที่จ่าย (" + _toDisplayString(_ctx.data.accountingData.taxWithheldPercent) + "%) ", 1),
                        _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.withholdingTax)) + " บาท ", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.totalPayAmount)) + " บาท ", 1)
                  ])
                ])
              ], 64)),
          (_ctx.chkExpiry)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                ((_ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B2_AwaitingPayment ||
          _ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B3_Paid) &&
        _ctx.data.statusOrderOnSeller !== _ctx.StatusOrderSeller.S4_AwaitingFulfillment
        )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDialogConfirmpayment(_ctx.data))),
                          class: "group relative w-full flex justify-center py-4 px-4 border border-transparent text-lg font-medium rounded-md text-white bg-green-island-500 hover:bg-green-island-600 focus:outline-none focus:ring-transparent"
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B3_Paid &&
              _ctx.data.statusOrderOnSeller == _ctx.StatusOrderSeller.S3_ToConfirm
              ? "แจ้งการชำระเงินใหม่"
              : "แจ้งการชำระเงิน") + " ", 1),
                          _hoisted_54,
                          _createTextVNode(" (" + _toDisplayString(_ctx.func_service.currency(_ctx.data.accountingData.totalPayAmount)) + " บาท) ", 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.chkExpiry)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (_ctx.data.statusOrderOnBuyer == _ctx.StatusOrderCustomer.B1_AwaitingConfirm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click-send'))),
                          class: "group relative w-full flex justify-center py-4 px-4 border border-transparent text-lg font-medium rounded-md text-white bg-green-island-500 hover:bg-green-island-600 focus:outline-none focus:ring-transparent"
                        }, _toDisplayString(_ctx.data.hasNoShipment ? "ยืนยันการสั่งซื้อ" : "ยืนยันข้อมูลการจัดส่ง"), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_paymentConfirmDialog, { ref: "paymentConfirm" }, null, 512)
  ], 64))
}